/**
 * @file teacher
 * @author 丁聪
 */

import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';

import './index.scss'

@withTranslation()

class Teacher extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() { }

  render() {
    let { t } = this.props;
    let numList = [
      { flag: 1, count: 800, text: t('teacher:education_item1') },
      { flag: 2, count: 100, text: t('teacher:education_item2') },
      { flag: 2, count: 100, text: t('teacher:education_item3') },
      { flag: 2, count: 100, text: t('teacher:education_item4') },
    ]
    return (
      <div className="teache">
        <div className="inner">
          <div className="study-title">{t('teacher:education')}</div>
          <div className="heng"></div>
          <ul className="number">
            {numList.map((item, index) => (
              <li key={'count-' + index}>
                {item.flag === 1 ? (
                  <div>{item.count}+</div>
                ) : (
                    <div>{item.count}%</div>
                  )}
                <div>{item.text}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

export default Teacher
